((drupalSettings) => {
  let index = 0;
  const nameElement = document.querySelector(".roll-call-name");
  const nameContainer = document.querySelector(".roll-call-container");
  const webformId = nameContainer.getAttribute("data-webform");
  const names = drupalSettings.webform_recent_signups[webformId].submissions;

  function runRollCall() {
    nameElement.innerHTML = `${names[index]} `;
    nameContainer.classList.remove("roll-call-name-animation");
    // eslint-disable-next-line no-void
    void nameContainer.offsetWidth; // me neither https://css-tricks.com/restart-css-animation/#aa-update-another-javascript-method-to-restart-a-css-animation
    nameContainer.classList.add("roll-call-name-animation");

    index += 1;
    if (index >= names.length) {
      index = 0;
      nameContainer.removeEventListener("animationend", runRollCall, false);
      nameContainer.classList.add("roll-call-name-animation-end");
    }
  }

  runRollCall();

  nameContainer.addEventListener("animationend", runRollCall, false);

  // Drupal.behaviors.webform_recent_signups = {
  //   attach(context) {
  //     const webformRecentSignupElements = once(
  //       "webform_recent_signup_elements",
  //       ".webform_submission--recent-signups",
  //       context
  //     );
  //     webformRecentSignupElements.forEach((element) => {
  //       let index = 1;
  //       const webformId = element.getAttribute("data-webform");
  //       const submissionNames =
  //         drupalSettings.webform_recent_signups[webformId];
  //       const nameElement = element.querySelector(".roll-call-name");
  //       nameElement.innerHTML = `${submissionNames[index]} `;
  //       element.classList.remove("roll-call-name-animation");
  //       // eslint-disable-next-line no-void
  //       void element.offsetWidth; // me neither https://css-tricks.com/restart-css-animation/#aa-update-another-javascript-method-to-restart-a-css-animation
  //       element.classList.add("roll-call-name-animation");
  //       index += 1;
  //       if (index >= submissionNames.length) {
  //         index = 0;
  //       }
  //     });
  //   },
  // };
})(drupalSettings);
